<template>
    <div class="page-container">
        <div class="container-fluid">
            <!-- Navigation Breadcrumb -->
            <div class="page-navigation">
                <div class="breadcrumb-custom">
                    <router-link to="/">
                        <i class="fas fa-home"></i> Home
                    </router-link>
                    <span class="separator">/</span>
                    <span>Borang</span>
                </div>
            </div>

            <!-- Page Header -->
            <div class="page-header">
                <h2 class="page-title">Muat Turun Borang</h2>
                <p class="page-subtitle">Borang rasmi institusi</p>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 col-lg-8">

                    <!-- Carian -->
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="fas fa-search"></i></span>
                        </div>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Cari borang…"
                            v-model="search"
                            @keyup.enter="loadForms"
                        />
                    </div>

                    <!-- Senarai borang -->
                    <div class="collapsible-list">
                        <div
                            class="collapsible-card mb-2"
                            v-for="item in forms"
                            :key="item.id"
                        >
                            <div class="list-item">
                                <div class="list-item-header">
                                    <i class="fas fa-file-pdf text-danger mr-2"></i>
                                    <div class="list-item-info">
                                        <span class="list-item-name">{{ item.title }}</span>
                                        <small class="text-muted d-block" v-if="item.description">
                                            {{ item.description }}
                                        </small>
                                        <small class="text-muted">
                                            {{ formatSize(item.file_size) }}
                                            · {{ item.download_count }} muat turun
                                        </small>
                                    </div>
                                    <button
                                        class="btn btn-sm btn-primary ml-auto"
                                        :disabled="downloadingId === item.id"
                                        @click="download(item)"
                                    >
                                        <i class="fas fa-download"></i>
                                        {{ downloadingId === item.id ? 'Sila tunggu…' : 'Muat Turun' }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Keadaan kosong -->
                        <div v-if="!loading && forms.length === 0" class="empty-state-sm">
                            <i class="fas fa-inbox"></i>
                            <p>Tiada borang tersedia</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'FormDownload',
    data() {
        return {
            loading: false,
            search: '',
            downloadingId: null,
        }
    },
    computed: {
        ...mapState('form', ['forms']),
    },
    mounted() {
        this.loadForms()
    },
    watch: {
        //if search is null or empty string, reload forms
        search(newValue) {
            if (!newValue) {
                this.loadForms()
            }
        },
    },
    methods: {
        async loadForms() {
            this.loading = true
            this.$Progress.start()
            try {
                await this.$store.dispatch('form/fetchForms', this.search)
                this.$Progress.finish()
            } catch (error) {
                this.handleApiError(error)
            } finally {
                this.loading = false
            }
        },

        async download(item) {
            this.downloadingId = item.id
            this.$Progress.start()
            try {
                const blob = await this.$store.dispatch('form/requestDownload', item.id)
                this.saveBlob(blob, item.original_name)
                this.$Progress.finish()
            } catch (error) {
                this.handleApiError(error)
                this.$swal('Ralat', 'Gagal memuat turun borang', 'error')
            } finally {
                this.downloadingId = null
            }
        },

        saveBlob(blob, filename) {
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = filename || 'borang.pdf'
            document.body.appendChild(a)
            a.click()
            a.remove()
            window.URL.revokeObjectURL(url)
        },

        formatSize(bytes) {
            if (!bytes) return '-'
            if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(0) + ' KB'
            return (bytes / 1024 / 1024).toFixed(1) + ' MB'
        },

        handleApiError(error) {
            this.$Progress.fail()
            if (error.response && (error.response.status === 401 || error.response.status === 419)) {
                this.$store.dispatch('authentication/cencelAuthen')
            }
            // eslint-disable-next-line no-console
            console.log(error)
        },
    },
}
</script>

<style scoped></style>
